import React from 'react';
import NewarkRichTextOutput from './NewarkRichTextOuput';
import BRSpan from '../../General/BRSpan';

export default props => {
  return (
    <div className="newark__ambassador-story-container" style={{ backgroundImage: `url(${props.backgroundImage})` }}>
      <div className="newark__ambassador-story-left">
        <div className="newark__ambassador-story-image-container">
          <img role="presentation" src={props.image} className="newark__ambassador-story-image"/>
        </div>
      </div>
      <div className="newark__ambassador-story-right">
        <h1 className="newark__ambassador-story-heading-1">
          <BRSpan str={props.headline}/>
        </h1>
        <div className="newark__ambassador-story-content">
          <NewarkRichTextOutput ops={props.bodyOps}/>
        </div>
      </div>
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkAmbassadorStory.js